import { render } from "./StampantiiView.vue?vue&type=template&id=28be48fd&scoped=true"
import script from "./StampantiiView.vue?vue&type=script&lang=js"
export * from "./StampantiiView.vue?vue&type=script&lang=js"

import "./StampantiiView.vue?vue&type=style&index=0&id=28be48fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28be48fd"]])

export default __exports__